// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1LKgt","colMaxWidth":"Table_colMaxWidth__3bpVy"};